<template>
  <div class="wh100">
    <xh-filter-layout title="招聘职位管理">
      <template slot="filter">
        <el-form :inline="true" size="medium">
          <el-form-item>
            <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="el-icon-plus" type="primary" @click="edit(null)">添加</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true">
          <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
          <el-table-column prop="job_name" label="岗位名称" align="center"  sortable></el-table-column>
          <el-table-column prop="education" label="学历要求" align="center" width="100" sortable></el-table-column>
          <el-table-column prop="major_direction" label="专业方向" align="center" sortable></el-table-column>
          <el-table-column prop="experience" label="经验要求" align="center" sortable></el-table-column>
          <el-table-column prop="work_location" label="工作地点" align="center" sortable></el-table-column>
          <el-table-column prop="department" label="公司/部门" align="center" sortable></el-table-column>
          <el-table-column prop="publish_time" label="发布时间" align="center" width="140" sortable></el-table-column>
          <el-table-column prop="visit_num" label="访问人数" align="center" width="100" sortable></el-table-column>
          <el-table-column prop="visit_num" label="状态" align="center" width="100" sortable>
            <template slot-scope="scope">
              {{scope.row.is_enable===1?"已发布":"未发布"}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="修改" placement="top">
                <el-button circle type="warning" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top">
                <el-button circle type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </MyTable>
      </template>
    </xh-filter-layout>
    <xh-dialog :title="dialog.title" :visible.sync="dialog.visible" width="55%" height="50%" :close-on-click-modal="false" @closed="closeModal">
      <PositionsEdit ref="editRef" :key="timer" :data="dialog.editRow" @closeModal="closeModal" center></PositionsEdit>
    </xh-dialog>
  </div>
</template>
<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
import PositionsEdit from "./components/PositionsEdit";
export default{
  components: { XhFilterLayout, MyPanel, MyTable,PositionsEdit},
  data(){
    return{
      title:'OpenPositions',
      form: {},
      table: {
        method: "POST",
        url: "/OpenPositions/getData",
        pageSize: 50,
      },
      checkRowId: [],
      timer:"",
      dialog: {
        title: "添加",
        visible: false,
        editRow: {}
      },
    }
  },
  methods:{
    query(){
      this.$refs.mytable.reload();
    },
    edit(row) {
      let that = this;
      that.timer = new Date().getTime();
      if (row == null) {
        that.dialog.title = "添加";
        that.dialog.editRow = {
          id: that.$util.guid(),
          job_name: "",
          education: "",
          major_direction:"",
          experience:"",
          work_location:"",
          department:"",
          visit_num:0,
          is_enable:1,
          flag: 0,//新增
        };
      } else {
        that.dialog.title = "修改";
        that.dialog.editRow = row;
        that.dialog.editRow.flag = 1;//修改
      }

      that.dialog.visible = true;
    },
    //关闭弹出页面
    closeModal() {
      this.dialog.visible = false;
      this.$nextTick(function () { this.query(); });
    },
    deleteRow(row) {
      let that = this;
      that.$confirm("删除后无法恢复, 确定要删除吗?", "提示", {confirmButtonText: "确定", cancelButtonText: "取消", type: "warning"})
          .then(() => {
            that.$api.post("/OpenPositions/deleteData", {id: row.id},
                function (res) {
                  if (res.code === "200") {
                    that.query();
                    that.$message.success("删除成功");
                  } else {
                    that.$message.error("删除失败");
                  }
                },
                function (res) {
                  //that.$message.error("服务器异常，删除出错");
                }
            );
          })
          .catch(() => {
          });

    },
  },
  computed: { },
  mounted() { },
  created() { },
  watch: { },
}


</script>
